import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import NormalValidation from "../Forms/FormValidation/unitsTypes/NormalValidation";

const UnitsTypesCreate = () => {
  document.title = "Novo Tipo de Orgãos de Estrutura - Khozi";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Tipos de Orgãos de Estrutura"
            breadcrumbItem="Novo Tipo de Orgão de Estrutura"
          />
          <NormalValidation />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UnitsTypesCreate;
